import React from "react";
import { css } from "@emotion/react";
import { SwarovskiButton } from "../../components/_shared-components/ui-elements/SwarovskiButton";
import type { TranslatedValue } from "@swo/storefront";
import { T } from "../../components/T";

export const PDPReviewsLoadMore: React.FC<{ onClick: () => void; label: TranslatedValue }> = ({ onClick, label }) => {
  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        padding: var(--p);
      `}
    >
      <SwarovskiButton as="button" onClick={onClick} variant="green">
        <span>
          <T>{label}</T>
        </span>
      </SwarovskiButton>
    </div>
  );
};
